if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner, .wk-cta-spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        if($('#second-id').val() != '#'){
          formData.append('items[0][id]', `${$('#second-id').val()}`); // extra shade added here 
          formData.append('items[0][quantity]', $('.quantity__input').val());
        } 
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // if on collection page and cart limit found, limit total by limit and individual products to 1
          const productGrid = document.getElementById('ProductGridContainer');
          if (productGrid) {
            let cartLimit = productGrid.dataset.cartLimit;
            if (cartLimit >= 0) {

              // lock added product
              let cartLimitMessage = this.submitButton.querySelector('.cart-limit-message');
              if (!cartLimitMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              cartLimitMessage.classList.remove('hidden');

              fetch(`${window.location.origin}/cart.js`).then((res) => res.clone().json().then((data) => {
                // console.log(data);
                let cartQuantity = 0;
                let lockedProducts = [];

                for (let cartItem of data.items) {
                  // console.log(cartItem);
                  for (let propertyKey of Object.keys(cartItem.properties)) {
                    if (propertyKey == `_limit-${productGrid.dataset.template}`) {
                      // console.log('found item in limited category');
                      cartQuantity += Number(cartItem.quantity);
                      lockedProducts.push(cartItem.id);
                      // console.log(cartItem);
                    }
                  }
                }

                productGrid.dataset.cartQuantity = cartQuantity;

                if (cartQuantity >= cartLimit) {
                  // lock all buttons
                  productGrid.querySelectorAll('input[name="id"] ~ button[type="submit"]').forEach((productButton) => {
                    let cartLimitMessage = productButton.querySelector('.cart-limit-message');
                    if (!cartLimitMessage) return;
                    productButton.setAttribute('aria-disabled', true);
                    productButton.querySelector('span').classList.add('hidden');
                    cartLimitMessage.classList.remove('hidden');
                  });
                } else {
                  // unlock all buttons except those in cart
                  productGrid.querySelectorAll('input[name="id"]').forEach((productInput) => {
                    let productButton = productGrid.querySelector(`input[name="id"][value="${productInput.value}"] ~ button[type="submit"]`);
                    let cartLimitMessage = productButton.querySelector('.cart-limit-message');
                    if (!cartLimitMessage) return;

                    if (lockedProducts.includes(Number(productInput.value))) {
                      productButton.setAttribute('aria-disabled', true);
                      productButton.querySelector('span').classList.add('hidden');
                      cartLimitMessage.classList.remove('hidden');
                    } else {
                      productButton.setAttribute('aria-disabled', false);
                      productButton.querySelector('span').classList.remove('hidden');
                      cartLimitMessage.classList.add('hidden');
                    }
                  });
                }
              }));
            }
          }

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
